import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { startCase } from 'lodash';
import classNames from 'classnames';
import showBarrier from '../../../utils/showBarrier';

const NavLink = ({
    url, hash, tabName, tabUrl, activeClassName, cssClasses,
}) => (
    <Link
        to={`${url}/${tabUrl}${hash}`}
        className={classNames('ui-tabs__tab', 'pp-tabs__tab', ...cssClasses)}
        activeClassName={activeClassName}
        onClick={event => showBarrier(event, `${url}/${tabUrl}${hash}`)}
    >
        {startCase(tabName)}
    </Link>
);

NavLink.defaultProps = {
    cssClasses: [],
};

NavLink.propTypes = {
    url: PropTypes.string.isRequired,
    hash: PropTypes.string,
    tabName: PropTypes.string.isRequired,
    tabUrl: PropTypes.string.isRequired,
    activeClassName: PropTypes.string.isRequired,
    cssClasses: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string, PropTypes.bool,
    ])),
};

export default NavLink;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/NavLink.jsx